import { TPopMessage } from './types'

// Function to be called by devs
// event is heard by PopMessageProvider and popMessage data is collected
export const popMessage = (popMessage: TPopMessage) => {
  const event = new CustomEvent('pop-message', { detail: popMessage })
  document.dispatchEvent(event)
}
